export default {"src":"/_next/static/media/link.5badd40e.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};